import {RouteObject} from 'react-router';
import React from 'react';
import {PricingPage} from '@common/billing/pricing-table/pricing-page';

const lazyTenantRoute = async (
  cmp: keyof typeof import('@common/billing/billing-page/routes/billing-page-routes.lazy'),
) => {
  const exports = await import(
    '@common/billing/billing-page/routes/billing-page-routes.lazy'
  );
  return {
    Component: exports[cmp],
  };
};

export const tenantBillingRoutes: RouteObject[] = [
  {
    path: 'tenant/pricing',
    element: <PricingPage />,
  },
  {
    path: 'tenant/checkout/:productId/:priceId',
    lazy: () => lazyTenantRoute('TenantCheckoutPage'),
  },
  {
    path: 'tenant/billing',
    lazy: () => lazyTenantRoute('TenantBillingPageLayout'),
    children: [
      {
        index: true,
        lazy: () => lazyTenantRoute('BillingPage'),
      },
      {
        path: 'change-payment-method',
        lazy: () => lazyTenantRoute('ChangePaymentMethodLayout'),
        children: [
          {
            index: true,
            lazy: () => lazyTenantRoute('ChangePaymentMethodPage'),
          },
          {
            path: 'done',
            lazy: () => lazyTenantRoute('ChangePaymentMethodDone'),
          },
        ],
      },
      {
        path: 'change-plan',
        lazy: () => lazyTenantRoute('ChangePlanPage'),
      },
      {
        path: 'change-plan/:productId/:priceId/confirm',
        lazy: () => lazyTenantRoute('ConfirmPlanChangePage'),
      },
      {
        path: 'cancel',
        lazy: () => lazyTenantRoute('ConfirmPlanCancellationPage'),
      },
      {
        path: 'renew',
        lazy: () => lazyTenantRoute('ConfirmPlanRenewalPage'),
      },
      {
        path: 'renew/manual-razorpay',
        lazy: () => lazyTenantRoute('ManualRazorpayRenewPage'),
      },
    ],
  },
];
